// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1mRGs","overflowing":"ReadFullNote_overflowing__19I0J"};